// material
import { AppBar, Box, Stack, Toolbar, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import Logo from '../../components/Logo';
import { androidTecnozapVersion } from '../../controller/android-interface-controller';

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: theme.shadows[3], // Usando sombras do próprio MUI para consistência
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Compatibilidade com dispositivos móveis
  backgroundColor: alpha(theme.palette.background.paper, 0.85), // Ajuste de opacidade
  [theme.breakpoints.up('lg')]: {
    width: '100%',
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

function AppNavBar() {
  return (
    <RootStyle>
      <ToolbarStyle>
        <Box sx={{ px: 2.5, display: 'inline-flex', alignItems: 'center' }}>
          <Logo />
          <Stack direction="column" sx={{ ml: 1 }}>
            <Typography variant="subtitle1" color="text.primary">
              TECNOZAP
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {`v${process.env.REACT_APP_VERSION}`}
              {window.Android && ` | ${androidTecnozapVersion()}`}
            </Typography>
          </Stack>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          {/* Adicione componentes extras aqui, como um botão de notificações */}
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}

export default AppNavBar;
